module.exports = __webpack_public_path__ + "assets/img/414_aboutus_img__colorsystem_1.a695a4ab.svg";